import React, { useContext, useState } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";
import AppContext from "context/AppContext";
import ResetPassword from "subscreens/general/reset-password/resetPassword";


function BuyerResetPassword() {

    const { baseUrl, Navigate, authToken } = useContext(AppContext);
    const location = useLocation();
    const [email] = useState(location.state?.email || "");
    const [otp] = useState(location.state?.otp || "");
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false);

    // ==========================
    // RESET PASSWORD
    // ==========================
    const handleReset = (password, confirmPassword) => {
        setLoading(true);
        axios.post(`${baseUrl}/buyer/otp/resetPassword`, {
            email: email,
            otp: otp,
            password: password,
            password_confirmation: confirmPassword,
            headers: {
                Authorization: `Bearer ${authToken}`,
            },
        })
            .then((response) => {
                if (response.data.success) {
                    setSuccess(true);
                    Swal.fire({
                        icon: "success",
                        title: "Success",
                        text: "Password reset successfully."
                    }).then(() => Navigate("/buyer/login"));
                } else {
                    Swal.fire({
                        icon: "error",
                        title: "Error",
                        text: response.data.message
                    });
                }
                setLoading(false);
            })
            .catch((error) => {
                Swal.fire({
                    icon: "error",
                    title: "Error",
                    text: error.response?.data?.message || "Something went wrong."
                });
                setLoading(false);
            });
    };

    return (
        <ResetPassword
            email={email}
            userType="buyer"
            handleReset={handleReset}
            loading={loading}
            success={success}
            loginPath="/buyer/login"
        />
    );
}

export default BuyerResetPassword;